export function getCompactContextBadgeClass(
  tone: 'emerald' | 'blue' | 'violet' | 'slate' | 'amber' | 'indigo' | 'rose'
) {
  const tones: Record<string, string> = {
    emerald: 'border-emerald-200 bg-emerald-50 text-emerald-700',
    blue: 'border-blue-200 bg-blue-50 text-blue-700',
    violet: 'border-violet-200 bg-violet-50 text-violet-700',
    amber: 'border-amber-200 bg-amber-50 text-amber-700',
    indigo: 'border-indigo-200 bg-indigo-50 text-indigo-700',
    rose: 'border-rose-200 bg-rose-50 text-rose-700',
  }
  return [
    'inline-flex items-center rounded-full border px-2 py-0.5 text-[10px] font-semibold leading-4 sm:px-2.5 sm:py-1 sm:text-[11px]',
    tones[tone] ?? 'border-slate-200 bg-slate-50 text-slate-600',
  ].join(' ')
}

export function getQuickActionButtonClass(variant: 'primary' | 'secondary') {
  return [
    'w-full rounded-lg border px-3 py-2 text-left text-sm font-semibold transition-colors sm:w-auto',
    variant === 'primary'
      ? 'border-brand/15 bg-white text-brand hover:bg-slate-50'
      : 'border-slate-200 bg-white text-slate-600 hover:bg-slate-50',
  ].join(' ')
}

export function getOrderHeaderLayoutClass() {
  return 'flex flex-col gap-2 lg:flex-row lg:items-start lg:justify-between'
}
